@if (showAlertaErro === true) {
  <div class="body-alert-modal">
    <div class="div-alert text-center" style="width: 559px;height: 379px">
      <div class="row" style="position: absolute;right: 40px;top: 15px;">
        <button
          class="btn-icon"
          aria-label="Fechar alerta de erro"
          (click)="fechaAlertaErro()"
          >
          <i class="fa fa-times ci-gray fa-2x" aria-hidden="true"></i>
        </button>
      </div>
      <div class="div-alert-erro-padrao">
        <img src="/assets/img/error-padrao.png" alt="Representa erro" width="90px">
        <h1>Ops, algo deu errado :(</h1>
        <p>{{descricaoErro}}</p>
        <button class="botao-alert-erro" (click)="fechaAlertaErro()" id="fechaAlertaErro">TENTAR NOVAMENTE</button>
      </div>
    </div>
  </div>
}
